import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WFWorker, JoiEvent } from 'src/app/store/events.era';
import { performerDisplayTypes } from 'src/app/store/performers.era';
import { Sponsor } from 'globals/store/sponsors.data';
import { Program, Session } from 'globals/store/programs.data';
import { str2Date } from 'globals/helpers/helpers';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Dictionary } from '@ngrx/entity';
import { Asset } from 'globals/store/assets.data';
import { exhibitorDisplayTypes } from 'globals/store/exhibitors.data';
import { JoiResource } from 'globals/store/resources.data';
import { TagPanelData } from 'globals/store/tags.data';
import { programSessionsActivitesMegaTagReselector } from '../../store/reselectors/programs.reselector';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { DialogTitleComponent } from '../program/dialog-title';
import { PerformersComponent } from 'src/app/components/performers/performers.component';
import { StaticSponsorCardsComponent } from '../sponsors/static-sponsor-cards.component';
import { ExpandingWrapperComponent } from 'src/app/components/wrappers/expanding-wrapper.component';
import { IconHolderComponent } from '../logistics/icon-holder.component';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { FileHandlerComponent } from 'src/app/components/file-handler/file-handler.component';
import { EditableNotesComponent } from '../program/editable-notes.component';
import { AssetsComponent } from '../assets/assets.component';
import { FileLinkComponent } from 'src/app/components/file-handler/file-link.component';
import { TagPanelViewComponent } from '../manage/tag-panel-view.component';
import { LabelTierDialogComponent } from 'src/app/components/label-marker/label-tier.dialog.component';
import { InformablePublicComponent } from 'src/app/components/informable/informable.public.component';
import { CommonModule } from '@angular/common';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';


@Component({
    selector: 'view-session-dialog',
    templateUrl: './onsite.dialog.viewSession.html',
    styleUrls: [`onsite.page.scss`, './onsite.dialog.viewSession.scss'],
    standalone: true,
    imports: [IconComponent, DialogTitleComponent, CommonModule, IdsToItemsPipe, PerformersComponent, StaticSponsorCardsComponent, ExpandingWrapperComponent, IconHolderComponent, InformablePublicComponent, LabelTierDialogComponent, TitleIconComponent, InputEditorComponent, FileHandlerComponent, EditableNotesComponent, AssetsComponent, FileLinkComponent, TagPanelViewComponent],
})
export class ViewSessionDialogComponent extends Wrapper<ViewSessionDialogComponent> {
  _file = "onsite.dialog.viewSession.component"
  currentEvent: JoiEvent
  session: Partial<Session> = {}
  workersByEmail: { [key: string]: WFWorker } = {}
  location: string
  date: Date
  sponsors: { [id:string]: Sponsor }
  performerDisplayTypes = performerDisplayTypes
  exhibitorDisplayType = exhibitorDisplayTypes.staticCard
  Y2K = new Date("1999/12/31")
  assets: Dictionary<Asset>
  resourceMap: Dictionary<JoiResource> = {}
  tagPanelDatas: Dictionary<TagPanelData> = {}

  constructor(public dialogRef: MatDialogRef<ViewSessionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ViewSessionDialogData) {
    super()
    // console.log("viewSession dialog data: ", data)
    this.session = data.session // no longer editable, so this is fine
    this.subProp(this.store.select('assets', 'entities'), 'assets')
    this.subProp(this.store.select('resources', 'entities'), 'resourceMap')
    this.selectProp(programSessionsActivitesMegaTagReselector, true, 'tagPanelDatas')
    this.date = data.date ? new Date(data.date) : data.program.date ? str2Date(data.program.date) : null
    this.date = typeof this.date !== "string" && this.date < this.Y2K ? null : this.date // sorry, no time travelling allowed <== correcting bug where the date came in as a very low integer
    this.subCallback(this.store.select('events', 'event'), event => {
      this.currentEvent = event
      const { venueId, location } = data.program
      const { venue, address } = event.venues[venueId] || {}
      this.location = `${location ? location: ''}${location && (venue || address) ? ', ' : ''}${venue ? venue: ''}${venue && address ? ', ' : ''}${address || ''}`
    })
    this.subProp(this.store.select('sponsors', 'entities'), 'sponsors')
    this.subProp(this.store.select('workforce', 'workersByEmail'), 'workersByEmail')
  }
}

export interface ViewSessionDialogData {
  program: Program,
  session: Session,
  date: Date,
}

